import React from "react";
import { connect } from "react-redux";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import BloqueoScheduler from "./BloqueoScheduler";
import ModalEditWeek from "./ModalEditWeek";
import ModalConflictWeek from "./ModalConflictWeek";
import ModalDeleteBlocking from "./ModalDeleteBlocking";

class Bloqueos extends React.PureComponent {
  render() {
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <ModalEditWeek />
        <ModalConflictWeek />        
        <BloqueoScheduler />
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  isLoading: state.bloqueosSel.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Bloqueos);
